import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Invest from "../pages/invest/page";
import Evidence from "../pages/evidence/page";
import Jiuchou from "../pages/jiuchou/page";
import JiuchouArchitecture from "../pages/jiuchou/architecture/page";
import JiuchouChain from "../pages/jiuchou/chain/page";
import YunNode from "../pages/jiuchou/yun-node/page";
import SupplyService from "../pages/jiuchou/supply-service/page";
import Consumption from "../pages/jiuchou/consumption/page";
import Settlement from "../pages/jiuchou/settlement/page";
import DataAi from "../pages/jiuchou/data-ai/page";
import Experience from "../pages/experience/page";
import Strategy from "../pages/strategy/page";
import Tech from "../pages/tech/page";
import Demo from "../pages/demo/page";
import Launch from "../pages/launch/page";
import Scale from "../pages/scale/page";
import Products from "../pages/products/page";
import ProductsServices from "../pages/products-services/page";
import Solutions from "../pages/solutions/page";
import News from "../pages/news/page";
import SmartFarm from "../pages/smart-farm/page";
import SmartFarmSolution from "../pages/smart-farm-solution/page";
import SmartParking from "../pages/smart-parking/page";
import RedPacket from "../pages/red-packet/page";
import SmartRestaurant from "../pages/smart-restaurant/page";
import SmartAgriculture from "../pages/smart-agriculture/page";
import SmartAgricultureTrace from "../pages/smart-agriculture/trace/page";
import SmartCatering from "../pages/smart-catering/page";
import SmartLogistics from "../pages/smart-logistics/page";
import IndustryConsulting from "../pages/industry-consulting/page";
import Cases from "../pages/cases/page";
import CaseDetail from "../pages/cases/detail/page";
import Epin from "../pages/epin/page";
import ZhongxianCommerce from "../pages/zhongxian-commerce/page";
import Weiju from "../pages/weiju/page";
import ContactBusiness from "../pages/contact/business/page";
import Search from "../pages/search/page";
import TracePassport from "../pages/trace-passport/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  // 关于我们
  {
    path: "/about",
    element: <Navigate to="/about/company" replace />,
  },
  {
    path: "/about/company",
    element: <About />,
  },
  {
    path: "/about/investor-relations",
    element: <Invest />,
  },
  {
    path: "/about/resources",
    element: <Evidence />,
  },
  // 兼容旧路径：投资与合作 → 关于我们/投资关系
  {
    path: "/invest",
    element: <Navigate to="/about/investor-relations" replace />,
  },
  // 产品与解决方案
  {
    path: "/products-services",
    element: <ProductsServices />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/solutions/smart-farm",
    element: <SmartFarm />,
  },
  {
    path: "/solutions/smart-farm-solution",
    element: <SmartFarmSolution />,
  },
  {
    path: "/solutions/smart-parking",
    element: <SmartParking />,
  },
  {
    path: "/solutions/parking-solution",
    element: <Navigate to="/solutions/smart-parking" replace />,
  },
  {
    path: "/solutions/red-packet",
    element: <RedPacket />,
  },
  {
    path: "/solutions/smart-restaurant",
    element: <SmartRestaurant />,
  },
  {
    path: "/solutions/smart-agriculture",
    element: <SmartAgriculture />,
  },
  {
    path: "/solutions/smart-agriculture/trace",
    element: <SmartAgricultureTrace />,
  },
  {
    path: "/solutions/smart-catering",
    element: <SmartCatering />,
  },
  {
    path: "/solutions/smart-logistics",
    element: <SmartLogistics />,
  },
  {
    path: "/industry-consulting",
    element: <IndustryConsulting />,
  },
  // 客户案例
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/cases/epin-food-safety",
    element: <Epin />,
  },
  {
    path: "/cases/zhongxian-farm-market",
    element: <ZhongxianCommerce />,
  },
  {
    path: "/trace/passport",
    element: <TracePassport />,
  },
  {
    path: "/cases/:slug",
    element: <CaseDetail />,
  },
  {
    path: "/weiju",
    element: <Weiju />,
  },
  // 联系我们
  {
    path: "/contact/business",
    element: <ContactBusiness />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  // 保留现有内容页面
  {
    path: "/jiuchou",
    element: <Jiuchou />,
  },
  {
    path: "/jiuchou/architecture",
    element: <JiuchouArchitecture />,
  },
  {
    path: "/jiuchou/chain",
    element: <JiuchouChain />,
  },
  {
    path: "/jiuchou/yun-node",
    element: <YunNode />,
  },
  {
    path: "/jiuchou/supply-service",
    element: <SupplyService />,
  },
  {
    path: "/jiuchou/consumption",
    element: <Consumption />,
  },
  {
    path: "/jiuchou/settlement",
    element: <Settlement />,
  },
  {
    path: "/jiuchou/data-ai",
    element: <DataAi />,
  },
  {
    path: "/experience",
    element: <Experience />,
  },
  {
    path: "/strategy",
    element: <Strategy />,
  },
  {
    path: "/tech",
    element: <Tech />,
  },
  {
    path: "/demo",
    element: <Demo />,
  },
  {
    path: "/launch",
    element: <Launch />,
  },
  {
    path: "/scale",
    element: <Scale />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/evidence",
    element: <Navigate to="/about/resources" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;